import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { instance } from "../utils/helper";
import { getAccessToken } from "../authentication/AuthLogin";

interface RequestType {
  method: string;
  url: string;
  headers?: any;
  onUploadProgress?: (progress: ProgressEvent) => any;
}

interface errorType {
  message: string;
  statusCode: number | undefined;
}

interface apiResponseType {
  data: any;
  statusCode: number | null;
  message: string;
  paging: any;
}

const useHttp = (requestConfig: RequestType) => {
  const [apiResponse, setApiResponse] = useState<any>();
  const [uploadProgress, setUploadProgress] = useState({
    started: false,
    pc: 0,
  });
  const [error, setError] = useState<errorType>({
    message: "",
    statusCode: undefined,
  });
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const hookHandler = async (data: any) => {
    setLoading(true);
    let token = "";
    try {
      token = await getAccessToken();
    } catch (err) {
      setError({
        message: typeof err === "string" ? err : "Failed to get access token",
        statusCode: undefined,
      });
      setLoading(false);
      return;
    }
    try {
      const response = await instance({
        method: requestConfig.method,
        url: requestConfig.url,
        data: data ? data : null,
        headers: {
          ...(requestConfig?.headers || {}),
          Authorization: `Bearer ${token}`,
        },
        onUploadProgress:
          requestConfig.method === "post"
            ? (progressEvent: any) => {
                setUploadProgress((prevState) => {
                  return { ...prevState, pc: progressEvent.progress * 100 };
                });
              }
            : undefined,
      });
      setError({
        message: "",
        statusCode: undefined,
      });

      if (response)
        setApiResponse({
          data: response?.data.data,
          statusCode: response?.data.code,
          message: response?.data?.message,
          paging: response?.data?.data?.totalElements,
        });
      setLoading(false);
      return { success: true, data: response?.data, error: null };
    } catch (error: any) {
      setApiResponse({ data: "", statusCode: 0, message: "", paging: {} });
      const errObj = {
        message: error?.response?.data?.message || error?.message,
        statusCode: error?.response?.status,
      };
      setError(errObj);
      setLoading(false);
      return { success: false, data: null, error: errObj };
    }
  };

  return [apiResponse, error, loading, hookHandler, uploadProgress] as const;
};

export default useHttp;
